import styled from 'styled-components';

export const ScreenScrapeForm = styled.form`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`;

export const ScreenScrapeFormFooter = styled.div`
  margin-top: auto;
`;
